'use client'
import { useState } from 'react'
import {
  useFloating,
  useDismiss,
  useRole,
  useClick,
  useInteractions,
  useId,
  FloatingFocusManager,
  FloatingOverlay,
  FloatingPortal,
} from '@floating-ui/react'

interface IProps {
  children: React.ReactNode
  onClose: () => void
}

export const PopupComponent = ({ children, onClose }: IProps) => {
  const [isOpen, setIsOpen] = useState(true)

  const { refs, context } = useFloating({
    open: isOpen,
    onOpenChange: (open) => {
      setIsOpen(open)
      if (!open) {
        onClose()
      }
    },
  })

  const click = useClick(context)
  const role = useRole(context)
  const dismiss = useDismiss(context, {
    outsidePressEvent: 'mousedown',
    escapeKey: true,
  })

  const { getFloatingProps } = useInteractions([click, role, dismiss])

  const headingId = useId()
  const descriptionId = useId()

  return (
    <FloatingPortal>
      {isOpen && (
        <FloatingOverlay
          className="z-[150] bg-black grid place-items-center bg-opacity-70 h-screen text-center"
          lockScroll
        >
          <FloatingFocusManager context={context}>
            <span
              className="popover relative block align-middle h-auto max-h-full w-auto max-w-full"
              ref={refs.setFloating}
              aria-labelledby={headingId}
              aria-describedby={descriptionId}
              {...getFloatingProps()}
            >
              {children}
            </span>
          </FloatingFocusManager>
        </FloatingOverlay>
      )}
    </FloatingPortal>
  )
}

export default PopupComponent
